import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Alerta from "../components/Alerta";

import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const RestaurarPassword = () => {
  const [tokenValido, setTokenValido] = useState(false);
  const [alerta, setAlerta] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);



  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const { token } = params

  const switchShowPass1 = () => setShowPass1(!showPass1);
  const switchShowPass2 = () => setShowPass2(!showPass2);

  useEffect(() => {
    const comprobarToken = async () => {
      try {


        setTokenValido(true);
      } catch (error) {
        setAlerta({
          msg: 'El token se ha expirado, volver a enviar el correo.',
          error: true,
          cargaPrincipal: true
        })

      }
    }
    comprobarToken();

  }, []);

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    if ([password1, password2].includes('')) {
      setAlerta({
        msg: `*${lbl_validacion_msj_todos_campos}.`,
        error: true,
        cargaPrincipal: false
      })
      return;
    }
    if (password1.length < 6) {
      setAlerta({
        msg: `${lbl_validacion_msj_contrasena_minimo} 6 ${lbl_validacion_digitos}.`,
        error: true,
        cargaPrincipal: false
      })
      return;
    }
    if (password1 !== password2) {
      setAlerta({
        msg: `${lbl_validacion_msj_campos_iguales}.`,
        error: true,
        cargaPrincipal: false
      })
      return;
    }


    try {
      setAlerta({});




      navigate('/auth/success');
    } catch (error) {
      setAlerta({
        msg: 'El codigo se a expirado o no valido, volver a enviar el correo.',
        error: true,
        cargaPrincipal: false
      })

    }
  }

  const { msg, cargaPrincipal } = alerta

  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        restaurar_contrasena: obtenerLabelEtiqueta(
          "lbl_restaurar_contrasena",
          listadoEtiquetas
        ),
        nueva_contrasena: obtenerLabelEtiqueta(
          "lbl_restaurar_nueva_contrasena",
          listadoEtiquetas
        ),
        repetir_contrasena: obtenerLabelEtiqueta(
          "lbl_restaurar_repetir_contrasena",
          listadoEtiquetas
        ),
        restaurar: obtenerLabelEtiqueta(
          "lbl_global_restaurar",
          listadoEtiquetas
        ),
        volver_inicio: obtenerLabelEtiqueta(
          "lbl_global_msj_volver_inicio",
          listadoEtiquetas
        ),
        lbl_validacion_msj_todos_campos: obtenerLabelEtiqueta(
          "lbl_validacion_msj_todos_campos",
          listadoEtiquetas
        ),
        lbl_validacion_msj_contrasena_minimo: obtenerLabelEtiqueta(
          "lbl_validacion_msj_contrasena_minimo",
          listadoEtiquetas
        ),
        lbl_validacion_digitos: obtenerLabelEtiqueta(
          "lbl_validacion_digitos",
          listadoEtiquetas
        ),
        lbl_validacion_msj_campos_iguales: obtenerLabelEtiqueta(
          "lbl_validacion_msj_campos_iguales",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { restaurar_contrasena, nueva_contrasena, repetir_contrasena, restaurar, volver_inicio, lbl_validacion_msj_todos_campos, lbl_validacion_msj_contrasena_minimo, lbl_validacion_digitos, lbl_validacion_msj_campos_iguales } = etiquetas;




  return (
    <div className="login-content va-middle">
      <div className="center">
        <div className="log-title">
          <h1>{restaurar_contrasena}</h1>
          <div className="separator"></div>
        </div>
        {msg && cargaPrincipal && (
          <div className="text-center mt-5">


            <Alerta alerta={alerta} />
            <Link to='auth' className="mt-4 d-block">
              {volver_inicio}
            </Link>
          </div>
        )}

        {msg && cargaPrincipal == false && (

          <>
            <Alerta alerta={alerta} />
          </>

        )}
        {tokenValido && (
          <form onSubmit={handleOnSubmit}>
            <div className="mb-4">
              <label htmlFor="inputPassword2" className="visually-hidden">
                Password
              </label>
              <div className="input-group flex-nowrap">
                <input
                  autoComplete="off"
                  type={showPass1 ? "text" : "password"}
                  className="form-control login-control form-control-sm"
                  id="inputPassword2"
                  placeholder={nueva_contrasena}
                  value={password1}
                  onChange={(e) => { setPassword1(e.target.value) }}
                />
                <button className="input-group-text login-control " id="addon-wrapping" onClick={switchShowPass1}
                  type="button">
                  {" "}
                  <svg
                    width="20"
                    height="13"
                    viewBox="0 0 20 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0002 4.125C10.6632 4.125 11.2991 4.37522 11.7679 4.82062C12.2368 5.26602 12.5002 5.87011 12.5002 6.5C12.5002 7.12989 12.2368 7.73398 11.7679 8.17938C11.2991 8.62478 10.6632 8.875 10.0002 8.875C9.33712 8.875 8.70124 8.62478 8.2324 8.17938C7.76356 7.73398 7.50016 7.12989 7.50016 6.5C7.50016 5.87011 7.76356 5.26602 8.2324 4.82062C8.70124 4.37522 9.33712 4.125 10.0002 4.125ZM10.0002 0.5625C14.1668 0.5625 17.7252 3.02458 19.1668 6.5C17.7252 9.97542 14.1668 12.4375 10.0002 12.4375C5.8335 12.4375 2.27516 9.97542 0.833496 6.5C2.27516 3.02458 5.8335 0.5625 10.0002 0.5625ZM2.65016 6.5C4.02516 9.16 6.86683 10.8542 10.0002 10.8542C13.1335 10.8542 15.9752 9.16 17.3502 6.5C15.9752 3.84 13.1335 2.14583 10.0002 2.14583C6.86683 2.14583 4.02516 3.84 2.65016 6.5Z"
                      fill="#5F5F5F"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="inputPassword3" className="visually-hidden">
                Password
              </label>
              <div className="input-group flex-nowrap">
                <input
                  autoComplete="off"
                  type={showPass2 ? "text" : "password"}
                  className="form-control login-control form-control-sm"
                  id="inputPassword3"
                  placeholder={repetir_contrasena}
                  value={password2}
                  onChange={(e) => { setPassword2(e.target.value) }}
                />
                <button className="input-group-text login-control " id="addon-wrapping" onClick={switchShowPass2}
                  type="button">
                  {" "}
                  <svg
                    width="20"
                    height="13"
                    viewBox="0 0 20 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0002 4.125C10.6632 4.125 11.2991 4.37522 11.7679 4.82062C12.2368 5.26602 12.5002 5.87011 12.5002 6.5C12.5002 7.12989 12.2368 7.73398 11.7679 8.17938C11.2991 8.62478 10.6632 8.875 10.0002 8.875C9.33712 8.875 8.70124 8.62478 8.2324 8.17938C7.76356 7.73398 7.50016 7.12989 7.50016 6.5C7.50016 5.87011 7.76356 5.26602 8.2324 4.82062C8.70124 4.37522 9.33712 4.125 10.0002 4.125ZM10.0002 0.5625C14.1668 0.5625 17.7252 3.02458 19.1668 6.5C17.7252 9.97542 14.1668 12.4375 10.0002 12.4375C5.8335 12.4375 2.27516 9.97542 0.833496 6.5C2.27516 3.02458 5.8335 0.5625 10.0002 0.5625ZM2.65016 6.5C4.02516 9.16 6.86683 10.8542 10.0002 10.8542C13.1335 10.8542 15.9752 9.16 17.3502 6.5C15.9752 3.84 13.1335 2.14583 10.0002 2.14583C6.86683 2.14583 4.02516 3.84 2.65016 6.5Z"
                      fill="#5F5F5F"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="text-center mt-5">
              <button type="submit" className="btn btn-send mb-3">
                {restaurar}
              </button>
              <Link to='/auth' className="mt-4 d-block">
                {volver_inicio}
              </Link>
            </div>
          </form>

        )}

      </div>
    </div>
  );
};

export default RestaurarPassword;
